export default "__VITE_ASSET__GM0swNDN__"